// import state from "./state";

const getters = {
  // getStateDataApi: () => {
  //   return state.dataAPI;
  // },
};

export default getters;
